import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { FooterComponent } from "../components/footer/footer-dashboard/footer.component";
import { HeaderComponent } from "../components/header/header.component";
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { LoadingService } from '../services/loading.service';
import { SectionLoadingComponent } from '../components/section-loading/section-loading.component';
import { UpgradeModalComponent } from '../components/subscription/upgrade-modal/upgrade-modal.component';
import { routeUrls } from '../constants/constants';
import { CommonService } from '../services/common.service';
import { isMobileApp } from '../utilities/mobile.utils';

@Component({
  selector: 'cricteams-layout',
  standalone: true,
  imports: [CommonModule,RouterModule, SidebarComponent, FooterComponent, HeaderComponent, SectionLoadingComponent, UpgradeModalComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent implements OnInit {
  @ViewChild(UpgradeModalComponent) upgradeModal!: UpgradeModalComponent;
  public activeSidebar = true;
  public isSectionLoading = false;
  public isMobileApp = false;
  currentUrl = false;

  constructor(private loadingService: LoadingService, private router: Router, private route: ActivatedRoute, private commomService: CommonService) {
    this.loadingService.sectionLoading$.subscribe((sectionLoading) => {
      this.isSectionLoading = sectionLoading;
    });

    this.commomService.isLoaderBgTransparent.subscribe((isLoaderBgTransparent) => {
      if(isLoaderBgTransparent) {
        this.currentUrl = false;
      }
      if(!isLoaderBgTransparent) {
        this.currentUrl = true;
      }
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.isMobileApp = isMobileApp(params);
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = this.checkRoute(event.url);
      }
    });
  }
  toggleClass() {
    this.activeSidebar = !this.activeSidebar;
  }

  onHeaderUpgradeClick() {
    this.upgradeModal.showFromHeader();
  }

  checkRoute(url:string) {
    switch (url) {
      case `/${routeUrls.ROOT}`:
      case `/${routeUrls.DASHBOARD}`:
      case `/${routeUrls.TOURNAMENTS}`:
      case `/${routeUrls.PLAYERS}`:
      case `/${routeUrls.PRACTICES}`:
      case `/${routeUrls.MATCHES}`:
        return true;
      default:
        return false;
    }
  }
}
